// load libraries
window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

require('@chenfengyuan/datepicker');
 
// load 3rd party components
 
require('bootstrap');

require('select2');
require('owl.carousel');  
// require('slick-carousel');


// load custom code
require('./functions');
require('./components');
require('./pages');

(function(){

    
    let _token = document.head.querySelector('meta[name="csrf-token"]').content;

	$.ajaxSetup({
		headers: {
			'X-CSRF-Token': _token
		}
	}); 

    $(document)
        .ajaxStart(( event ) => {
            let elm = event.target.activeElement;
            if(!($(elm).hasClass('icon-notification'))){
                $('.loading').show();
            }
        })
        .ajaxComplete(() => $('.loading').hide());

    $('.dropdown-toggle').click(function(e) {
        if ($(document).width() > 768) {
            e.preventDefault();
        
            var url = $(this).attr('href');
        
            if (url !== '#') {
                window.location.href = url;
            }
        }
    });

    //Date Picker
    $('.datebox').datepicker();
    $('.datebox-month').datepicker({
        'format': 'mm - yyyy',
        'startView': 2,
    });
    $(document).on('click', '.icon-calendar', function () {
        let datebox = $(this).siblings('.datebox');
        let dateboxmonth = $(this).siblings('.datebox-month');
        datebox.datepicker("show");
        dateboxmonth.datepicker("show");
    });


    // search
    let $searchForm = $('#search-form');

    $('a.icon-search').on('click', function() {
       $searchForm.toggle();
    });

    let $searchType = $('select[name="search-type"]');
    $searchType.on('change', () => {
        let $option = $('option:selected', $searchType);
        $searchForm.attr('action', $option.data('action'));
    })

    // polling notifications
    if($('#UserIsLogged').val() === 'true'){
        setInterval(() => {
            $.ajax({
                url: '/refresh-notifications',
                global: false,
                success: (res) => {
                    $('#notification-bell').html(res).on('click', () => {
                        $('.Header-user .notifications-container').css('visibility', 'visible');
                    })
                }
            })
        },15000);
    }

    // subscribe
    $(document).on('click', '#newsletter-btn', function () {

        let on200 = (res) => {
            $('#newsletter-form').hide();
            $('#subscription-ok').html(res).show();
        };

        let on400 = (res) => {
            $('#newsletter-form').find('.alert').remove();
            let error = res.responseJSON;
            let div = $('<div>').addClass('alert alert-warning').html(error).fadeOut(5000);
            $('#newsletter-form').prepend(div);
        };
        ajaxSubmitForm($('#newsletter-form'), on200, on400);
    });

    $(document).on('submit', '#newsletter-form', function (e) {

        e.preventDefault();

        let on200 = (res) => {
            $('#newsletter-form').hide();
            $('#subscription-ok').html(res).show();
        };

        let on400 = (res) => {
            $('#newsletter-form').find('.alert').remove();
            let error = res.responseJSON;
            let div = $('<div>').addClass('alert alert-warning').html(error).fadeOut(5000);
            $('#newsletter-form').prepend(div);
        };
        ajaxSubmitForm($('#newsletter-form'), on200, on400);
    });

    $(document).on('shown.bs.modal','#signup-modal', function () {
        $.ajax({
            url: '/clear-redirect',
            method: 'POST',
            dataType: 'json',
            statusCode: {
                200: (res) => { },
                400: (res) => {console.error(res.responseJSON.error)}
            }
        });
    });

})();